import { TableModule } from 'primeng/table';
import { TranslatePipe } from '@ngx-translate/core';

import { NgTemplateOutlet } from '@angular/common';
import {
  input,
  signal,
  output,
  computed,
  Component,
  TemplateRef,
  contentChild,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SvgIcon } from '../../ui/svg-icon';
import { ButtonIcon } from '../../ui/button-icon';
import { MenuItems, MenuDirective } from '../../ui/menu';

@Component({
  selector: 'app-table',
  imports: [TableModule, NgTemplateOutlet, SvgIcon, MenuDirective, TranslatePipe, ButtonIcon],
  templateUrl: './table.html',
  styleUrl: './table.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'app-table',
  },
})
export class Table {
  public items = input.required<any[]>();

  public dataKey = input<string>('value');

  public canSelected = input<boolean>(false);

  public withOptions = input(false);

  public additionalButtonName = input('');

  public loading = input<boolean>(false);

  public menuItems = input<MenuItems>([]);

  protected rowClickEvent = output<any>();

  protected buttonClickEvent = output<any>();

  protected topTemplate = contentChild('top', { read: TemplateRef });

  protected headerTemplate = contentChild('header', { read: TemplateRef });

  protected bodyTemplate = contentChild('body', { read: TemplateRef });

  protected footerTemplate = contentChild('footer', { read: TemplateRef });

  protected selectedItems = signal<any[]>([]);

  protected canShowOptions = computed(() => {
    return this.withOptions() && this.menuItems().length > 0;
  });

  protected onRowSelect(event: any | null) {
    if (this.canSelected()) {
      this.selectedItems.update(() => {
        return {
          ...this.selectedItems(),
          ...event.data,
        };
      });
    }
  }

  protected onButtonClick(additionalButtonName: string) {
    this.buttonClickEvent.emit(additionalButtonName);
  }

  protected onRowClick(row: any) {
    const selection = window.getSelection();

    if (selection && selection.toString().length > 0) {
      return;
    }
    this.rowClickEvent.emit(row);
  }
}
